import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { SiteOverviewSite, SiteStatusSite } from "../../site-status-types";

function getCustomerColumn(): MRT_ColumnDef<SiteOverviewSite | SiteStatusSite> {
  return {
    header: "Kunde (bis 01.06.26)",
    accessorKey: "customer",
    filterFn: "includesString"
  };
}

export { getCustomerColumn };
